exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dp-page-num{position:fixed;height:24px;width:100%;bottom:8px;color:#fff;text-align:center;line-height:20px;opacity:0;z-index:-1;user-select:none;pointer-events:none}.dp-page-num .num{display:inline-block;min-width:70px;line-height:24px;border-radius:35px;background:#000;opacity:.7}.dp-page-num.show{transition:opacity 1s ease 0s;opacity:1;z-index:1}.dp-page-num.hide{transition:opacity 1s ease-out 0s;opacity:0;z-index:1}", ""]);

// exports
